import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetTagNFeEntradaResponse } from '../../responses/repo-dfe/get-tag-nfe-entrada.response';
import { CriarTagNFeEntradaResponse } from '../../responses/repo-dfe/criar-tag-nfe-entrada.response';
import { TagNFeEntradaRequest } from '../../requests/repo-dfe/tag-nfe-entrada.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
    providedIn: 'root',
})
export class TagNFeEntradaService extends CommonService {
    private readonly apiUrl: string = environment.urlApiRepoDFe + 'TagNFeEntrada';

    constructor(private httpClient: HttpClient) {
        super();
    }

    public getAll(descricao: string = '', pagina: number = 1, tamanhoPagina: number = 20): Observable<GetTagNFeEntradaResponse> {
        let params = new HttpParams()
            .set('pagina', pagina.toString())
            .set('tamanhoPagina', tamanhoPagina.toString());

        if (descricao) {
            params = params.set('descricao', descricao);
        }

        return this.httpClient
            .get<GetTagNFeEntradaResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
            .pipe(catchError(this.handleError));
    }

    public getById(id: number): Observable<CriarTagNFeEntradaResponse> {
        const url = `${this.apiUrl}/idTagNFeEntrada/${id}`;
        return this.httpClient
            .get<CriarTagNFeEntradaResponse>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public create(request: TagNFeEntradaRequest): Observable<CriarTagNFeEntradaResponse> {
        return this.httpClient
            .post<CriarTagNFeEntradaResponse>(this.apiUrl, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public update(id: number, request: TagNFeEntradaRequest): Observable<CriarTagNFeEntradaResponse> {
        const url = `${this.apiUrl}/idTagNFeEntrada/${id}`;
        return this.httpClient
            .put<CriarTagNFeEntradaResponse>(url, request, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public delete(id: number): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/idTagNFeEntrada/${id}`;
        return this.httpClient
            .delete<ReturnStruct>(url, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }

    public deleteBulk(ids: number[]): Observable<ReturnStruct> {
        const url = `${this.apiUrl}/bulk-delete`;
        return this.httpClient
            .post<ReturnStruct>(url, { ids }, this.addHeaderToken())
            .pipe(catchError(this.handleError));
    }
}
